import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import DueDatePage from '@rental-manager/pages/Onboarding/DueDatePage/component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import paths from '@rental-manager/pathsManifest';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { leaseId } = state.payments.landlord.onboarding[propertyId];
  const { newTermSettings, leasesForProperty } = state.payments.landlord.property;
  let { paymentDayOfTheMonth } = newTermSettings;
  const { startDate: startDateFromLease } = leasesForProperty[leaseId] || {};

  if (!newTermSettings?.paymentDayOfTheMonth && startDateFromLease) {
    paymentDayOfTheMonth = new Date(startDateFromLease).getUTCDate();
  }

  return {
    paymentDayOfTheMonth,
    editMode: newTermSettings.editMode,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: (paymentSettings, editMode) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() =>
        dispatch(
          saveNewTermSettings({
            paymentDayOfTheMonth: editMode ? paymentSettings.editDayOfTheMonth : paymentSettings.paymentDayOfTheMonth,
          }),
        ),
      )
      .then(() => dispatch(push(baseUrl + paths.dashboard.termLengthPage)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.dashboard.setupNewTermPage))),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (paymentSettings) => dispatchProps.onSubmit(paymentSettings, stateProps.editMode),
  onClose: () => dispatchProps.onClose(stateProps.editMode),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DueDatePage);
